import { Filter } from "@/models/Pageable"

export class FilterTeam extends Filter {
  q = ""
  accountId = ""
  userId = ""
  isSuperadmin = false
  forSearch = false
  demo = false
  includeDemo = false
  projectId = ""
  projectName = ""
  teamName = ""
  excludeUserId = ""
  ignoreSubscriptionFilter = false
  excludeEmptyTeams = false
  enabled?: boolean
  constructor(props?: Partial<FilterTeam>) {
    super(props as FilterTeam)
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
  }

  getJsonObj({ isTextFormatting }: { isTextFormatting?: boolean } = { isTextFormatting: true }) {
    const data = {
      q: this.q,
      accountId: this.accountId,
      userId: this.userId,
      demo: this.demo,
      projectId: this.projectId,
      excludeUserId: this.excludeUserId,
      ignoreSubscriptionFilter: this.ignoreSubscriptionFilter,
      includeDemo: this.includeDemo,
      excludeEmptyTeams: this.excludeEmptyTeams,
      enabled: this.enabled
    }

    return super.getJsonObj({ params: data, isTextFormatting })
  }

  static create(props) {
    return new FilterTeam(props)
  }

  static createDefault() {
    const props = {
      q: "",
      accountId: "",
      userId: "",
      isSuperadmin: false,
      forSearch: false,
      demo: false,
      projectId: ""
    }

    return new FilterTeam(props)
  }
}
